import { Component, OnInit } from '@angular/core';
import { GlobalsService } from 'src/app/services/globals.service';

@Component({
  selector: 'app-disclaimerprint',
  templateUrl: './disclaimerprint.component.html',
  styleUrls: ['./disclaimerprint.component.less']
})
export class DisclaimerprintComponent implements OnInit {
  studentType: number = 0;

  constructor(private globals: GlobalsService) { }

  ngOnInit() {
    if(this.globals.quotationDetail){
      this.studentType = this.globals.quotationDetail.studentType;
    }
  }

}
